import { gql } from '@apollo/client'
import type { UseMutationProps, UseMutationResult } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'

export const shippingAddressFragment = `shippingAddress{
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      company
      street3
      name
      phone
    }`

export const billingAddressFragment = `billingAddress{
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      company
      street3
      name
      phone
    }
    taxAmount`

export const buildUpdateOrderAddressQuery = (fragment = '') => {
  return gql(`
  mutation orderUpdateOrderAddress($input: JSON!) {
    orderUpdateOrderAddress(input: $input) {
      _id
      ${billingAddressFragment}
      ${shippingAddressFragment}
      ${fragment}
    }
  }
`)
}

export const orderUpdateOrderAddressQuery = buildUpdateOrderAddressQuery()

export const useUpdateOrderAddress = ({ query, ...props } = {} as unknown as UseMutationProps): UseMutationResult => {
  query = query ?? orderUpdateOrderAddressQuery
  return useMutation({ query, ...props })
}
